import { render, staticRenderFns } from "./ConnectorsCanvas.vue?vue&type=template&id=512c133e"
import script from "./ConnectorsCanvas.vue?vue&type=script&lang=js"
export * from "./ConnectorsCanvas.vue?vue&type=script&lang=js"
import style0 from "./ConnectorsCanvas.vue?vue&type=style&index=0&id=512c133e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports